var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rest-record-item',{key:[_vm.type, _vm.pageType].join(''),attrs:{"type":_vm.type,"pageType":_vm.pageType,"restData":_vm.restData},on:{"tab":_vm.onTab,"pageTypeChange":_vm.onPageTypeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }